import React, { useRef, useEffect, useState } from "react";
import { getSessionData } from "../utils/auth";
import NavHeader from "../components/navigation/NavHeader";
import Footer from "../components/navigation/Footer";
import GoUpDown from "../components/navigation/GoUpDown";
import AsideLeft from "../components/aside/AsideLeft";
import AsideRight from "../components/aside/AsideRight";
import { Editor } from '@tinymce/tinymce-react';
import { useParams } from "react-router-dom";
import { addPost, getForum, postLinkPreview } from "../core/communities";
import { useNavigate } from "react-router-dom";
import Loader from 'react-loaders';
import toast, { Toaster } from 'react-hot-toast';
import ForumHeaderSection from "../components/forum/ForumHeaderSection";
import CommunityLayout from "../components/layouts/CommunityLayout";
import NavUserAvatar from "../components/navigation/NavUserAvatar";
import FaceSmileIcon from "../components/icons/FaceSmile";
import PhotoIcon from "../components/icons/Photo";
import ArticleIcon from "../components/icons/ArticleIcon";
import EmojiPicker from 'emoji-picker-react';
import LinkPreviewUI from '../components/post/LinkPreview';
import RichTextEditor, { getWordCountFromHtml } from '../components/RichTextEditor';
import { usePageTitle } from '../hooks/usePageTitle';

const ForumPostForm = () => {
    usePageTitle('New Post - Wefayo');
    const { comid, id } = useParams();
    const navigate = useNavigate();

    const TINY_MCE_API_KEY = process.env.REACT_APP_TINY_MCE;
    const editorRef = useRef(null);

    let loggedInUser = getSessionData();
    if (loggedInUser === null) {
        navigate(`/`);
    }

    const [editorKey, setEditorKey] = useState(4);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState([]);

    const [forum, setForum] = useState(null);
    const [title, setTitle] = useState("");
    const [subTitle, setSubTitle] = useState("");
    const [details, setDetails] = useState(``); //cbh
    const [media, setMedia] = useState("");
    const [breadcrumbPages, setBreadcrumbPages] = useState([]);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [postType, setPostType] = useState('post');
    const [linkPreviewed, setLinkPreviewed] = useState();
    const [lastPreviewedUrl, setLastPreviewedUrl] = useState("");

    const CLOUDINARY_URL = process.env.REACT_APP_CLOUDINARY_URL || "";
    const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET || "";
    const [isFileUpLoading, setIsFileUpLoading] = useState(false);

    useEffect(() => {
        const fetchForum = async () => {
            const data = await getForum(id);
            setForum(data);

            setBreadcrumbPages([
                { name: data?.community.title, href: `/`, current: false },
                { name: data?.title, href: `/community/${data?.community._id}/forum/${id}`, current: false },
                { name: "Add Post", href: ``, current: true },
            ]);
        }
        fetchForum();
    }, []);

    const clearForm = () => {
        setTitle("");
        setSubTitle("");
        setDetails("");//<p></p>
        setEditorKey(editorKey * 2);
        setMedia("");
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors([]);
        setIsLoading(true);

        // const wordCount = editorRef.current.plugins.wordcount.getCount();
        const wordCount = getWordCountFromHtml(details);
        // console.log("wordCount", wordCount);
        if (wordCount === 0) {
            setIsLoading(false);
            setErrors(["Please add post description"]);
            return false;
        }

        let content = details;
        if (content.length === 0) {
            content = "<p></p>";
        }

        const inputs = {
            forumId: forum._id,
            title,
            subTitle,
            details: content,
            media
        };
        let response = null;
        response = await addPost(inputs);
        setIsLoading(false);
        if (response !== true) {
            return setErrors(response);
        }
        clearForm();
        toast.success('Post was submitted successfully', {
            icon: '✅'
        });

        navigate(`/community/${comid}/forum/${forum._id}`);
    }



    const handleOnFileChange = async (changeEvent) => {
        const reader = new FileReader();
        reader.onload = async function (onLoadEvent) {
            setIsFileUpLoading(true);
            setMedia(onLoadEvent.target.result);
            //https://www.youtube.com/watch?v=7lhUsK-FxYI
            // const form = e.currentTarget
            // const fileInput = Array.from(form.elements).find(({name}) => name == 'select-image');
            const fileInput = changeEvent.target;
            const formData = new FormData();
            formData.append('file', fileInput.files[0]);
            formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
            const data = await fetch(CLOUDINARY_URL, {
                method: "POST",
                body: formData
            })
                .then(r => r.json())
                .then((data) => {
                    setMedia(data.secure_url);
                    setIsFileUpLoading(false);
                });
        }
        if (reader && reader.readAsDataURL && changeEvent.target.files && changeEvent.target.files.length > 0) {
            reader.readAsDataURL(changeEvent.target.files[0]);
        }
    };

    const [maximumLength, setMaximumLength] = useState(140000);
    const handleEditorUpdate = (text, editor) => {
        const length = editor.getContent({ format: 'text' }).length;
        if (length <= maximumLength) {
            setDetails(text);
        } else {
            toast.error('Maximum content length exceeded. Accepts upto 20,000 words', {
                icon: '🚫',
                duration: 1500
            });
        }
    };

    const goToProfile = (e, user) => {
        e.preventDefault();
        if (loggedInUser) {
            navigate(`/profile/${user._id}`);
        }
    };

    const toggleEmojiPicker = () => {
        if (editorRef.current) {
            editorRef.current.focus();
            editorRef.current.execCommand('mceEmoticons');
        } else {
            // console.log("No editorRef.current");
        }
    };

    const togglePostType = () => {
        const newType = postType === 'post' ? 'article' : 'post'
        setPostType(newType)
        if (newType == 'post') {
            setTitle("");
        }
    }


    // Function to fetch link preview data
    const fetchLinkPreview = async (targetUrl) => {
        if (lastPreviewedUrl == targetUrl && linkPreviewed != null) {
            return;
        }

        let url = targetUrl;
        // Check if the URL is valid
        if (!url.match(/^(https?:\/\/|www\.)/i)) {
            return;
        }

        // Normalize the URL (add https:// if missing)
        if (url.indexOf('://') === -1) {
            url = 'https://' + url;
        }

        try {
            // console.log("The going to fetch url:::::", url);
            const response = await postLinkPreview(url);
            // console.log("The link preview response ", response);
            if (Array.isArray(response)) {
                setLinkPreviewed(null);
                setLastPreviewedUrl(null);
            } else {
                setLinkPreviewed(response);
                setLastPreviewedUrl(targetUrl);
            }
        } catch (error) {
            console.error('Error fetching link preview:', error);
        }
    };

    const handleCloseClick = () => {
        setLinkPreviewed(null);
        setLastPreviewedUrl(null);
    }

    // Extract the last <a> href (or URL-like text) from editor HTML
    const getLastAnchorUrlFromHtml = (htmlString) => {
        //if (!html || typeof html !== 'string') return '';
        // const tempDiv = document.createElement('div');
        // tempDiv.innerHTML = html;
        // const anchors = tempDiv.querySelectorAll('a');
        // if (anchors.length === 0) {
        //     return '';
        // }
        // const lastAnchor = anchors[anchors.length - 1];
        // let url = (lastAnchor.getAttribute('href') || '').trim();
        // if (!url || url.length === 0) {
        //     const text = (lastAnchor.textContent || '').trim();
        //     url = text;
        // }
        // return url;

        // Use a DOM parser to safely process the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");

        let links = [];

        // 1. Collect from <a href="...">
        doc.querySelectorAll("a[href]").forEach(a => links.push(a.href));

        // 2. Collect from <link>, <script src>, <img src>, etc.
        doc.querySelectorAll("[src], [href]").forEach(el => {
            if (el.src) links.push(el.src);
            if (el.href) links.push(el.href);
        });

        // 3. Regex fallback: catch plain-text URLs in the HTML string itself
        const urlRegex = /\b((https?|wss?|ftp|file|mailto):\/\/[^\s"'<>]+)/gi;
        let match;
        while ((match = urlRegex.exec(htmlString)) !== null) {
            links.push(match[0]);
        }
        // Return the *last* detected link, or null if none
        const url = links.length > 0 ? links[links.length - 1] : null;
        return url;
    };

    const handleOnEditorChange = (rawHtmlInput) => {
        setDetails(rawHtmlInput);
        // Detect last <a> element and preview it
        try {
            const url = getLastAnchorUrlFromHtml(rawHtmlInput);
            if (url && url.length > 0) {
                fetchLinkPreview(url);
            }
        } catch (e) { }
    }

    return (
        // <MainLayout currentPage={"addpost"} mobileChatClasses="" >
        <CommunityLayout currentPage={"events"} onCommunitiesLoaded={()=>{}} >
            <div className="bg-red-400x min-h-[calc(100vh-60px)] md:min-h-[calc(100vh-125px)] md:min-h-none mt-14 lg:mt-0 flex-1 flex flex-col  ">
                <ForumHeaderSection
                    forum={forum}
                    breadcrumbPages={breadcrumbPages}
                />
                {/* <ForumHeroSection forum={forum} /> */}
                <form action="#" method="POST" onSubmit={handleSubmit} className="bg-green-400x flex flex-col flex-grow bg-primary-white  max-h-[815px] overflow-auto rounded-b-md drop-shadow-sm  md:mb-0 border border-gray-900/10">

                    {/* <h2 className="text-lg font-semibold  text-gray-900 px-4 pt-2 pb-0 mb-0">New Post</h2>
                        <p className=" text-sm text-gray-600 px-4 pt-2 pt-0">
                            Fill out and submit this form to add a new post to the forum.
                        </p> */}

                    <div class="p-2 flex flex-row justify-between items-center ">
                        {loggedInUser &&
                            <div class="flex flex-row items-center gap-x-2">
                                <NavUserAvatar user={loggedInUser} link={"#"} imgSizeClass={`w-[48px] h-[48px] max-w-[48px] max-h-[48px] block`} />

                                <div className=" flex flex-col justify-between flex-grow ">
                                    <div className={`text-xs font-semibold leading-6x text-primary-gray-900`}>
                                        <div onClick={(e) => goToProfile(e, loggedInUser)} className="whitespace-nowrap cursor-pointer">
                                            <div style={{ fontSize: "16px" }}>{loggedInUser.username}</div>
                                            {/* <div className="absolute inset-x-2 top-[4px] bottom-0 font-bold w-fit" >
                                        {index+1}
                                    </div> */}
                                        </div>
                                    </div>
                                    <div className={`mt-1 text-sm flex leading-1 text-gray-900 whitespace-nowrap capitalize`}>
                                        Post To {breadcrumbPages[1]?.name ?? ''}
                                    </div>
                                </div>
                            </div>
                        }



                        {/* <button
                            disabled={isLoading}
                            onClick={togglePostType}
                            className="pointer flex flex-row gap-x-[2px] cursor-pointer rounded-sm text-purple-900 px-3 py-1.5 text-sm md:text-md font-bold hover:text-purple-800 "
                        >
                            <ArticleIcon />
                            Convert To {postType === 'post' ? 'Article' : 'Post'}
                        </button> */}
                    </div>

                    <div className="bg-white flex-grow  border-t border-purple-900/10  ">
                        {/* title */}
                        {/* {postType === 'article' && */}
                        <div className="col-span-full p-4">
                            <label htmlFor="title" className="block text-sm font-medium leading-6 text-gray-900">
                                <b>Title</b>
                                <span className="text-red-900 mx-1">*</span>
                            </label>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    name="title"
                                    id="title"
                                    autoComplete="title"
                                    value={title}
                                    disabled={isLoading}
                                    onChange={(e) => setTitle(e.target.value)}
                                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-gray-100 disabled:cursor-progress"
                                />
                            </div>
                        </div>
                        {/* } */}
                        {/* sub title */}
                        {/* <div className="col-span-full">
                                        <label htmlFor="sub-title" className="block text-sm font-medium leading-6 text-gray-900">
                                            <b>Sub Title</b>
                                        </label>
                                        <div className="mt-2">
                                            <input
                                                type="text"
                                                name="sub-title"
                                                id="sub-title"
                                                value={subTitle}
                                                disabled={isLoading}
                                                onChange={(e) => setSubTitle(e.target.value)}
                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-gray-100 disabled:cursor-progress"
                                            />
                                        </div>
                                    </div> */}
                        {/* media */}
                        <div className="col-span-full mb-4 hidden">

                            <label htmlFor="photo" className="block text-sm font-medium leading-6 text-gray-900">
                                <b>Image</b>
                            </label>

                            <div className="flex items-start justify-start bg-grey-lighter mt-2">
                                <label disabled={isLoading} htmlFor="select-image" className={"flex flex-row items-center px-3 py-0.5 bg-white text-blue rounded-sm shadow-sm tracking-wide  border border-blue  hover:bg-purple-100 hover:text-gray-400 gap-x-2 " + (isLoading ? "cursor-not-allowed" : "cursor-pointer")}>
                                    {!isFileUpLoading &&
                                        <svg className="w-5 h-5" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                        </svg>
                                    }
                                    <span className={`text-xs font-medium leading-6 text-gray-900 ${isFileUpLoading ? 'flex items-center pr-2 bg-purple-100' : ''} `}>
                                        {isFileUpLoading && <Loader type="ball-beat" style={{ transform: 'scale(0.5)' }} />}
                                        {!isFileUpLoading &&
                                            <span>
                                                {(!media || media.length === 0) ? 'Upload' : 'Upload'} Picture
                                            </span>
                                        }
                                        {isFileUpLoading && "uploading"}
                                    </span>
                                    <input id="select-image" disabled={isLoading} name="select-image" type='file' className="hidden" onChange={handleOnFileChange} />
                                </label>
                            </div>

                            {media.length > 0 &&
                                <div className="flex flex-col mt-2 m" >
                                    <img
                                        className="inline-block max-h-[350px] rounded-sm"
                                        src={media}
                                        alt=""
                                    />
                                </div>
                            }
                        </div>

                        {postType === 'article' &&
                            <div className={`col-span-full px-4 `}>
                                <label htmlFor="about" className="block text-sm font-medium leading-6 text-gray-900">
                                    <b>Article Details</b>
                                    <span className="text-red-900 mx-1">*</span>
                                    {/* <span className="mt-3 ml-2 text-xs leading-1 text-gray-400">
                                                    - Provide details of your post
                                                </span> */}
                                </label>

                                <div className="flex flex-col border border-purple-900/10 rounded-md pb-4 ">
                                    <div className="article-editor px-4">
                                        <RichTextEditor value={details}  onChange={handleOnEditorChange} />

                                        {/* <Editor
                                            id="add-post-form"
                                            key={'editor1-' + editorKey}
                                            apiKey={TINY_MCE_API_KEY}
                                            onInit={(evt, editor) => editorRef.current = editor}
                                            onEditorChange={handleEditorUpdate}
                                            value={details}
                                            init={{
                                                min_height: 280,
                                                menubar: false,
                                                plugins:
                                                    'advlist link autolink lists link image  anchor ' +
                                                    'searchreplace visualblocks ' +
                                                    'media table past wordcount autoresize emoticons'
                                                ,
                                                toolbar: 'undo redo | link formatselect | fontfamily fontsize | ' +
                                                    'bold italic emoticons backcolor | alignleft aligncenter ' +
                                                    'alignright alignjustify | outdent indent | ' +
                                                    'bullist numlist',
                                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:18px }',
                                                font_size_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
                                                content_style: `
                                                        .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
                                                            //color: rgba(34,47,62,.7);
                                                            left: 5px !important;
                                                        }
                                                        
                                                        .mce-content-body p {
                                                            margin-top: 0;
                                                            margin-bottom: 0;
                                                        }
                                                    `,

                                            }}
                                        /> */}
                                    </div>

                                    {media.length > 0 &&
                                        <div className="flex flex-col mt-2 px-4 relative" >
                                            {/* <img
                                            className="inline-block max-h-[350px] rounded-sm"
                                            src={media}
                                            alt=""
                                        /> */}

                                            <button
                                                type="button"
                                                class="absolute top-1 right-5  z-10 p-1.5 rounded-full bg-gray-900/70 bg-gray-900 text-white  transition-all duration-200 hover:scale-110"
                                                aria-label="Close preview"
                                                onClick={() => setMedia("")}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x">
                                                    <path d="M18 6 6 18"></path>
                                                    <path d="m6 6 12 12"></path>
                                                </svg>
                                            </button>

                                            <div className="w-full h-[270px] bg-no-repeat bg-center bg-cover rounded-md"
                                                style={{ backgroundImage: `url(${media})`, backgroundColor: "#fafafa" }}
                                            >
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        }

                        {postType === 'post' &&
                            <div className={`col-span-full `}>

                                <div className="post-editor">

                                    <RichTextEditor value={details} onChange={handleOnEditorChange} />

                                    {/* <Editor
                                        id="add-post-form"
                                        key={'editor1-' + editorKey}
                                        apiKey={TINY_MCE_API_KEY}
                                        onInit={(evt, editor) => editorRef.current = editor}
                                        onEditorChange={handleEditorUpdate}
                                        value={details}
                                        init={{
                                            toolbar: 'bold italic emoticons',
                                            menubar: false,
                                            statusbar: false,
                                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:20px }',
                                            placeholder: ` What is on your mind ?`,
                                            auto_focus: 'add-post-form',
                                            plugins: 'autoresize autolink emoticons wordcount',
                                            autoresize_overflow_padding: 5,
                                            autoresize_bottom_margin: '25s',
                                            content_style: `
                                                        .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
                                                            color: #222f3e;
                                                            left: 5px !important;
                                                        }
                                                        
                                                        .mce-content-body p {
                                                            margin-top: 0;
                                                            margin-bottom: 0;
                                                        }
                                                    `,
                                            setup: function (editor) {
                                                // console.log("The editor is initialized", editor);

                                                editor.on('NodeChange', function (e) {
                                                    if (e.element.nodeName === 'A') {
                                                        // console.log("Link detected in editor");
                                                        const url = e.element.getAttribute('href');
                                                        // console.log("url", url);
                                                        if (url) {
                                                            fetchLinkPreview(url, editor, e.element);
                                                        }
                                                    }
                                                });
                                            }
                                        }}
                                    />  */}
                                </div>

                                {media.length > 0 &&
                                    <div className="flex flex-col mt-2 px-4 relative" >
                                        {/* <img
                                        className="inline-block max-h-[350px] rounded-sm"
                                        src={media}
                                        alt=""
                                    /> */}
                                        <button
                                            type="button"
                                            class="absolute top-1 right-5 z-10 p-1.5 rounded-full bg-gray-900/70 bg-gray-900 text-white  transition-all duration-200 hover:scale-110"
                                            aria-label="Close preview"
                                            onClick={() => setMedia("")}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x">
                                                <path d="M18 6 6 18"></path>
                                                <path d="m6 6 12 12"></path>
                                            </svg>
                                        </button>

                                        <img className="w-full bg-center object-cover rounded-md"
                                            src={media}
                                        />
                                        {/* style={{ backgroundImage: `url(${media})`, backgroundColor: "#fafafa" }} */}
                                        {/* </div> */}
                                    </div>
                                }

                            </div>
                        }

                        {linkPreviewed &&
                            <LinkPreviewUI data={linkPreviewed} handleCloseClick={handleCloseClick} />
                        }

                    </div>

                    <div className="mt-2 py-4 px-4 border-t border-purple-900/10 flex flex-row justify-between items-center ">

                        <div className="flex flex-row justify-start gap-x-2 items-center">
                            {/* <button role="button"
                                type="button"
                                disabled={isLoading}
                                className="w-fit flex justify-center rounded-sm  px-3 py-2 text-md font-semibold text-gray-900 hover:text-gray-700  disabled:cursor-not-allowed"
                                onClick={toggleEmojiPicker}
                            >
                                <FaceSmileIcon className="w-6 h-6" />
                            </button> */}

                            <label disabled={isLoading} htmlFor="select-image"
                                className="w-fit flex justify-center rounded-sm  px-3 py-2 text-md font-semibold text-gray-900 hover:text-gray-700  disabled:cursor-not-allowed"
                            >
                                <PhotoIcon className="w-6 h-6" />
                                <input id="select-image" disabled={isLoading} name="select-image" type='file' className="hidden" onChange={handleOnFileChange} />
                            </label>
                        </div>

                        <button role="button"
                            type="submit"
                            disabled={isLoading}
                            className="w-fit  flex justify-center rounded-md bg-purple-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-purple-800 disabled:cursor-not-allowed"
                        >
                            {isLoading && <Loader type="ball-beat" style={{ transform: 'scale(0.5)' }} />}
                            POST
                        </button>

                    </div>

                    {errors.length > 0 &&
                        <div className="app-error text-red-400 font-bold text-xs py-5 px-10">
                            {errors[0]}
                        </div>
                    }

                </form>
            </div >
        </CommunityLayout >
    );
};

export default ForumPostForm;
